import React from 'react';
import s from './ProductCard.module.css';
import Button from '../Button/Button';
import { Link, useRouteMatch } from 'react-router-dom';

function ProductCard({ products }) {
  const { url } = useRouteMatch();
  return (
    <div className={s.ProductContainer}>
      <ul className={s.ProductsList}>
        {products.map(({ id, img, title, description, statusNew }) => (
          <li key={id} className={s.ProductCard}>
            {statusNew && <div className={s.newProduct}>Новинка</div>}
            <div className={s.imgContainer}>
              <img src={img} alt={title} className={s.ProductImg} />
            </div>

            <div className={s.descriptionWrapper}>
              <h3 className={s.title}>{title}</h3>
              <p className={s.text}>{description}</p>
            </div>
            <div className={s.Button}>
              <Link to={`${url}/${id}`}>
                <Button name={'Детальніше'} />
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ProductCard;
